import * as React from 'react';
import Base from './Base';
const Paragraph = props => <Base {...props} component="div"/>;
export default Paragraph;



// WEBPACK FOOTER //
// ./components/typography/Paragraph.tsx